import "./ReturnsExchanges.css"
import React from "react";
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
const ReturnsExchanges = () => {
    return (
        <>
            <div class="tf-page-title">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center ">
                            <h4 className='breadcrumbtitle'>Returns & Refund</h4>
                            <div className=' breadcrumb'>
                                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                                <h6>Returns & Refund</h6></div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="container-a">
                <div class="datacontainer"><br />

                    <div style={{ fontSize: "20px", textAlign: "justify" }}><b>1.  Clear Return &amp; Refund Policy</b></div>
                    <br />

                    <p style={{ paddingLeft: "20px" }}>
                        <b>•    Non-refundable items</b><span style={{ fontWeight: "400" }}>: Specify which items (Our Clearance items are final sales and it is AS IS) are non-refundable.</span>
                        <br />

                        <b>•   Return eligibility</b><span style={{ fontWeight: "400" }}>: State that returns will only be accepted if the item is in its original condition and packaging.</span>

                        <br />
                        <b>•   Return Window:</b><span style={{ fontWeight: "400" }}> If there is a sizing or quality issue, customers must inform RoyalHood customer service at </span><b>support@royalhood.in</b><span style={{ fontWeight: "400" }}> as soon as the item is received. As these are rental items, to be eligible for a full refund, the item must be returned within 24 hours of delivery</span><b>&nbsp;Time limits</b><span style={{ fontWeight: "400" }}>: </span>
                        <br />

                        <b>•   Refund Method</b><span style={{ fontWeight: "400" }}>: </span><span style={{ fontWeight: "400" }}>Refunds will be processed using the same payment method used for the original transaction</span>
                        <br />
                        <br />
                    </p>
                    <div style={{ fontSize: "20px" }}><b>2. Detailed Terms of Service</b></div>
                    <br />


                    <p style={{ paddingLeft: "20px" }}><b>Customer Responsibilities:</b></p><br />

                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Customers are responsible for the care and maintenance of the rented items while they are in their possession. This includes avoiding stains, damage, or excessive wear.</span>
                    <br /><span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   All rented items must be returned by the specified due date. Late returns may incur additional fees.</span>
                    <br /><span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Customers should package the items securely for return shipment to prevent any damage during transit.</span>
                    <br /><br />

                    <b style={{ paddingLeft: "20px" }}> Product Condition at Return:</b>
                    <br />

                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   All rented items should be returned in their original condition.</span>
                    <br /> <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Excessive wear, stains, or damage to the products may result in additional charges to cover cleaning or repair costs. Customers will be notified of any charges incurred for<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; damages after the items are returned.</span>
                    <br /><br />

                    <b style={{ paddingLeft: "20px" }}> Additional Charges:</b>
                    <br />

                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Any damages, stains, or missing items will be assessed upon return, and customers will be charged accordingly.</span>
                    <br /><span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Charges may include, but are not limited to, repair costs, replacement fees, or additional cleaning fees.</span>
                    <br />
                    <br />
                    <b> 3. Strict Rental Agreement:</b>
                    <br /><br />


                    <b style={{ paddingLeft: "20px" }}>1. Agreement to Terms:</b>

                    <br />
                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   By completing your order, you agree to abide by the terms set forth in this rental agreement. This agreement outlines your responsibilities as a customer and the <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;conditions under which items are rented.</span>

                    <br />
                    <b style={{ paddingLeft: "20px" }}>2. Customer Obligations:</b>
                    <br />

                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   You are responsible for the care and maintenance of the rented items during the rental period. This includes ensuring that the items are kept in good condition and not <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;subjecting them to excessive wear and tear.</span>

                    <br />
                    <b style={{ paddingLeft: "20px" }}> 3. Return Conditions:</b>
                    <br />

                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Rented items must be returned in their original condition. Items should be free from stains, damage, and alterations. Please ensure that all items are packaged securely to<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; prevent damage during return shipping.</span>

                    <br />
                    <b style={{ paddingLeft: "20px" }}> 4. Damage Fees:</b>
                    <br />

                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   If items are returned with stains, damage, or excessive wear, you will incur additional fees to cover cleaning, repair, or replacement costs. You will be notified of any charges<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; assessed after the items are returned.</span>
                    <br />

                    <b style={{ paddingLeft: "20px" }}> 5. Late Return Policy:</b>

                    <br />
                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Items must be returned by the specified due date. </span>
                    {/* Late returns will incur a fee of $25 Per outfit for each day the item is overdue.</span> */}
                    <br />

                    <b style={{ paddingLeft: "20px" }}> 6. Acknowledgment of Terms:</b>
                    <br />

                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   You acknowledge that you have read and understood the terms of this rental agreement. By checking the box during the checkout process, you agree to be bound by these <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;terms.</span>

                    <br />
                    <b style={{ paddingLeft: "20px" }}>7. Signature Requirement:</b>
                    <br />

                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   A signature or a checkbox indicating your acceptance of this rental agreement is required at checkout. Failure to agree to these terms will result in the cancellation of your <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;order.</span>
                    <br />

                    <b style={{ paddingLeft: "20px" }}> 8. Contact Information:</b>
                    <br />


                    <span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   For any questions regarding this rental agreement, please contact our customer service team at </span><b>support@royalhood.in</b><span style={{ fontWeight: "400" }}>.</span>

                    <br /><br />
                    <p ><strong>Terms and Conditions for Made-to-Order Items</strong></p>
                    <br />
                    <strong style={{ paddingLeft: "20px" }}>Non-Refundable Policy</strong>

                    <p style={{ paddingLeft: "40px" }}><span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   All made-to-order items are non-refundable. Once an order is placed, production begins immediately, making cancellations or refunds unavailable.</span></p>

                    <strong style={{ paddingLeft: "20px" }}>Production Timeline</strong>

                    <p style={{ paddingLeft: "40px" }}><span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Please note that made-to-order items require a specific production timeline. Estimated delivery times will be provided at checkout, though delays may occasionally<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; occur due to factors outside our control.</span></p>

                    <strong style={{ paddingLeft: "20px" }}>Customization Requests</strong>

                    <p style={{ paddingLeft: "40px" }}><span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Customization requests are welcome but must be confirmed at the time of order. Once production has started, changes cannot be made to the order details.</span></p>

                    <strong style={{ paddingLeft: "20px" }}>Exchanges</strong>

                    <p style={{ paddingLeft: "40px" }}><span style={{ fontWeight: "400", paddingLeft: "20px" }}>•   Exchanges are not permitted for made-to-order items due to the personalized nature of the product. </span></p>

                    <strong style={{ paddingLeft: "20px" }}>Acceptance of Terms</strong>

                    <p style={{ paddingLeft: "40px" }}><span style={{ fontWeight: "400" }}>•   By placing a made-to-order purchase, you acknowledge and accept these terms. For any questions, feel free to reach out to our customer support team.</span></p>

                </div >
            </div >
            <div class="tf-toolbar-bottom type-1150">
                <div class="toolbar-item">
                    <a style={{ color: "black" }} href="/">
                        <div class="toolbar-icon">
                            <IoHome />
                        </div>
                        <div class="toolbar-label">Home</div>
                    </a>
                </div>
                <div class="toolbar-item">
                    <a style={{ color: "black" }} href="/products" >
                        <div class="toolbar-icon">
                            <BiCategoryAlt />
                        </div>
                        <div class="toolbar-label">Shop</div>
                    </a>
                </div>
                <div class="toolbar-item">
                    <a style={{ color: "black" }} href="/SearchBar" >
                        <div class="toolbar-icon">
                            <IoSearchOutline />
                        </div>
                        <div class="toolbar-label">Search</div>
                    </a>
                </div>
                {/* <div class="toolbar-item">
                    <a style={{ color: "black" }} href="#" >
                        <div class="toolbar-icon">
                            <MdOutlineAccountCircle />
                        </div>
                        <div class="toolbar-label">Account</div>
                    </a>
                </div> */}

                <div class="toolbar-item">
                    <a style={{ color: "black" }} href="/cart">
                        <div class="toolbar-icon">
                            <FaShoppingCart />
                        </div>
                        <div class="toolbar-label">Cart</div>
                    </a>
                </div>
            </div>
        </>
    );
};
export default ReturnsExchanges;